import { render } from "./Header.vue?vue&type=template&id=2b02acc5&scoped=true&ts=true"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"

import "./Header.vue?vue&type=style&index=0&id=2b02acc5&scoped=true&lang=css"

import exportComponent from "/tmp/nginx/vue-single-page-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b02acc5"]])

export default __exports__